export default class Collapse {
    constructor(container, options) {
        this.container = container;
        this.options = {
            item: '.js-collapse-item',
            toggle: '.js-collapse-toggle',
            content: '.js-collapse-content',
            activeClass: 'is-active',
            ...options,
        };
    }

    init() {
        if (this.container.classList.contains('plugin-collapse-initialized')) return;

        this.getItems(this.container).forEach((item) => {
            const content = item.querySelector(this.options.content);
            content.style.height = 0;
            content.style.display =
                getComputedStyle(content).display && getComputedStyle(content).display !== 'none'
                    ? getComputedStyle(content).display
                    : 'block';
            content.style.overflow = 'hidden';
        });

        window.addEventListener('load', () => {
            this.bindClickEvents();
        });

        this.container.classList.add('plugin-collapse-initialized');
    }

    onAjaxLoaded() {
        this.bindClickEvents();
    }

    bindClickEvents() {
        this.getItems(this.container).forEach((item) => {
            const toggles = Array.from(item.querySelectorAll(this.options.toggle));

            toggles.forEach((toggle) => {
                toggle.addEventListener('click', (event) =>
                    this.handleClick(event, item, item.classList.contains('is-active')),
                );

                if (item.classList.contains('is-active')) {
                    this.open(item);
                } else {
                    this.close(item);
                }
            });
        });
    }

    getItems(container) {
        return Array.from(container.querySelectorAll(this.options.item));
    }

    handleClick(event, item, active) {
        this.toggleItem(event, item, active);
    }

    closeAllItems() {
        this.getItems(this.container).forEach((item) => {
            this.close(item);
        });
    }

    toggleItem(event, item, active) {
        event.preventDefault();

        if (active) {
            this.close(item);
        }

        if (!active) {
            this.open(item);
        }
    }

    close(item) {
        const toggle = item.querySelector(this.options.toggle);
        const content = item.querySelector(this.options.content);
        const contentHeight = content.firstElementChild.scrollHeight;
        content.style.height = `${contentHeight}px`;
        requestAnimationFrame(() => {
            content.style.height = 0;
        });
        item.classList.remove(this.options.activeClass);
        toggle.classList.remove(this.options.activeClass);
        content.classList.remove(this.options.activeClass);
    }

    open(item) {
        const toggle = item.querySelector(this.options.toggle);
        const content = item.querySelector(this.options.content);
        const contentHeight = content.firstElementChild.scrollHeight;
        content.style.height = `${contentHeight}px`;
        content.addEventListener(
            'transitionend',
            () => {
                content.style.height = null;
            },
            {once: true},
        );
        item.classList.add(this.options.activeClass);
        toggle.classList.add(this.options.activeClass);
        content.classList.add(this.options.activeClass);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const collapses = Array.from(document.querySelectorAll('.js-collapse'));
    collapses.forEach((container) => {
        const collapse = new Collapse(container);
        collapse.init();
    });
});
